import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const usergroupApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: '/api/' }),
    reducerPath: 'usergroupApi',
    endpoints: (build) => ({
        usergroupList: build.query<any, string>({
            query: (name) => `groups`,
        }),
    }),
})

export const { 
    useUsergroupListQuery,
} = usergroupApi
